// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__N2N3s","header":"Admin_header__+hc6v"};